<div class="fixed top-30 right-0 p-4 z-50 w-full md:w-auto max-w-full md:max-w-md flex flex-col items-end gap-3 pointer-events-none">
  @for (notification of notifications; track notification) {
    <div
      [@notificationAnimation]="'visible'"
      class="w-full pointer-events-auto shadow-lg rounded-lg overflow-hidden flex items-stretch"
      [ngClass]="getNotificationClass(notification.type)"
      >
      <!-- Icon container -->
      <div class="flex items-center justify-center p-4">
        <div
          class="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold"
          [ngClass]="getIconClass(notification.type)"
          >
          {{ getIconContent(notification.type) }}
        </div>
      </div>
      <!-- Content -->
      <div class="flex-1 p-4 pr-2">
        <div class="font-medium text-gray-900 dark:text-white">{{ notification.message }}</div>
      </div>
      <!-- Close button -->
      <button
        (click)="closeNotification(notification.id)"
        class="p-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors duration-200"
        >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>
      <!-- Progress bar for auto-close notifications -->
      @if (notification.autoClose) {
        <div class="absolute bottom-0 left-0 right-0 h-1 bg-gray-200 dark:bg-gray-700">
          <div
            [@progressAnimation]="{value: 'end', params: {duration: notification.duration}}"
            class="h-full"
            [ngClass]="getIconClass(notification.type)">
          </div>
        </div>
      }
    </div>
  }
</div>
